/* MEET THE OTHER PRINTS strip: fetch the prints index, filter to the current
 * form, sort same-meaning designs first, render up to 12 cards.
 *
 * Register boundary (hard, per the copywriting skill): faith designs and the
 * rest of the catalogue never share this rail. A faith product shows only
 * faith prints; everything else excludes them. Until sass designs carry their
 * own marker this is the conservative reading of "faith and sass never appear
 * together".
 *
 * Renders nothing (container stays hidden) when fewer than 3 cards survive —
 * a discovery rail of one or two reads as leftovers, not a collection. */
(function () {
  'use strict';

  var MAX_CARDS = 12;
  var MIN_CARDS = 3;

  function init(root) {
    if (root.__init) return;
    root.__init = true;

    var src = root.getAttribute('data-prints-src');
    var form = root.getAttribute('data-prints-form');
    var design = root.getAttribute('data-prints-design');
    var meaning = root.getAttribute('data-prints-meaning');

    fetch(src)
      .then(function (res) { return res.json(); })
      .then(function (index) {
        var list = (index.byForm && index.byForm[form]) || [];
        var cards = list.filter(function (d) {
          if (d.design === design) return false;
          if (meaning === 'faith') return d.meaning === 'faith';
          return d.meaning !== 'faith';
        });

        cards.sort(function (a, b) {
          var am = a.meaning === meaning ? 0 : 1;
          var bm = b.meaning === meaning ? 0 : 1;
          if (am !== bm) return am - bm;
          return a.design.localeCompare(b.design);
        });

        cards = cards.slice(0, MAX_CARDS);
        if (cards.length < MIN_CARDS) return;

        var rail = root.querySelector('[data-prints-rail]');
        cards.forEach(function (d) {
          var a = document.createElement('a');
          a.className = 'afroyla-prints__card';
          a.href = '/products/' + d.handle;

          var img = document.createElement('img');
          var sep = d.img.indexOf('?') === -1 ? '?' : '&';
          img.src = d.img + sep + 'width=220';
          img.alt = d.design;
          img.loading = 'lazy';
          img.width = 96;
          img.height = 96;

          var name = document.createElement('span');
          name.textContent = d.design;

          a.appendChild(img);
          a.appendChild(name);
          rail.appendChild(a);
        });

        root.removeAttribute('hidden');
      })
      .catch(function () {
        /* index missing or malformed: the strip simply never appears */
      });
  }

  function adoptAll() {
    document.querySelectorAll('[data-other-prints]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adoptAll);
  } else {
    adoptAll();
  }

  // Sibling-size navigation swaps the product section in place; adopt strips
  // that arrive after load.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-other-prints]')) init(node);
          else if (node.querySelector && node.querySelector('[data-other-prints]')) adoptAll();
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
